// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./NaplexPrep.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MPJE prep keeps the NAPLEX layout system and swaps the accent treatment to blue. */
.mpje-prep .naplex-prep-glow-1 {
  background: #2563eb;
}

.mpje-prep .naplex-prep-glow-2 {
  background: #0ea5e9;
}

.mpje-prep .naplex-prep-glow-3 {
  background: #22d3ee;
}

.mpje-prep .naplex-prep-badge {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.3);
  color: #93c5fd;
}

.mpje-prep .naplex-prep-hero h1 {
  filter: drop-shadow(0 0 60px rgba(59, 130, 246, 0.18));
}

.mpje-prep .naplex-prep-hero h1 span {
  background: linear-gradient(135deg, #bfdbfe, #60a5fa, #2563eb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.mpje-prep .naplex-prep-btn-primary {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.4);
  color: #93c5fd;
}

.mpje-prep .naplex-prep-btn-primary:hover {
  background: rgba(59, 130, 246, 0.24);
  border-color: rgba(59, 130, 246, 0.58);
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.22);
}

.mpje-prep .naplex-prep-stat-value {
  color: #93c5fd;
}

.mpje-prep .naplex-prep-flow-num--2 {
  background: rgba(14, 165, 233, 0.15);
  color: #38bdf8;
  border-color: rgba(14, 165, 233, 0.3);
}

.mpje-prep .naplex-prep-flow-num--3 {
  background: rgba(37, 99, 235, 0.15);
  color: #60a5fa;
  border-color: rgba(37, 99, 235, 0.3);
}

.mpje-prep .naplex-prep-area-card--totals {
  background: rgba(59, 130, 246, 0.06);
  border-color: rgba(59, 130, 246, 0.2);
}

.mpje-prep .naplex-prep-area-card--totals .naplex-prep-area-name {
  color: #93c5fd;
}

.mpje-prep .naplex-prep-area-card--totals .naplex-prep-area-node {
  background: rgba(59, 130, 246, 0.08);
  border-color: rgba(59, 130, 246, 0.16);
}

.mpje-prep .naplex-prep-compare-card--us {
  border-color: rgba(59, 130, 246, 0.28);
}

.mpje-prep .naplex-prep-compare-card--us .naplex-prep-compare-label {
  color: #93c5fd;
}

.mpje-prep .naplex-prep-compare-card--us .naplex-prep-compare-icon {
  color: #60a5fa;
}

.mpje-prep .naplex-prep-price-amount {
  color: #93c5fd;
}

/* MPJE founders banner — overrides green→blue from NaplexPrep.css */
.mpje-prep .naplex-prep-founders-banner {
  background: rgba(59, 130, 246, 0.10);
  border-color: rgba(59, 130, 246, 0.35);
  color: #93c5fd;
  box-shadow: 0 0 22px rgba(59, 130, 246, 0.10), inset 0 0 0 1px rgba(255,255,255,0.02);
}

.mpje-prep .naplex-prep-founders-dot {
  background: #93c5fd;
  box-shadow: 0 0 8px rgba(147, 197, 253, 0.85);
}
`, "",{"version":3,"sources":["webpack://./src/pages/MpjePrep.css"],"names":[],"mappings":"AAEA,qFAAqF;AACrF;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C","sourcesContent":["@import './NaplexPrep.css';\n\n/* MPJE prep keeps the NAPLEX layout system and swaps the accent treatment to blue. */\n.mpje-prep .naplex-prep-glow-1 {\n  background: #2563eb;\n}\n\n.mpje-prep .naplex-prep-glow-2 {\n  background: #0ea5e9;\n}\n\n.mpje-prep .naplex-prep-glow-3 {\n  background: #22d3ee;\n}\n\n.mpje-prep .naplex-prep-badge {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.3);\n  color: #93c5fd;\n}\n\n.mpje-prep .naplex-prep-hero h1 {\n  filter: drop-shadow(0 0 60px rgba(59, 130, 246, 0.18));\n}\n\n.mpje-prep .naplex-prep-hero h1 span {\n  background: linear-gradient(135deg, #bfdbfe, #60a5fa, #2563eb);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.mpje-prep .naplex-prep-btn-primary {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: rgba(59, 130, 246, 0.4);\n  color: #93c5fd;\n}\n\n.mpje-prep .naplex-prep-btn-primary:hover {\n  background: rgba(59, 130, 246, 0.24);\n  border-color: rgba(59, 130, 246, 0.58);\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.22);\n}\n\n.mpje-prep .naplex-prep-stat-value {\n  color: #93c5fd;\n}\n\n.mpje-prep .naplex-prep-flow-num--2 {\n  background: rgba(14, 165, 233, 0.15);\n  color: #38bdf8;\n  border-color: rgba(14, 165, 233, 0.3);\n}\n\n.mpje-prep .naplex-prep-flow-num--3 {\n  background: rgba(37, 99, 235, 0.15);\n  color: #60a5fa;\n  border-color: rgba(37, 99, 235, 0.3);\n}\n\n.mpje-prep .naplex-prep-area-card--totals {\n  background: rgba(59, 130, 246, 0.06);\n  border-color: rgba(59, 130, 246, 0.2);\n}\n\n.mpje-prep .naplex-prep-area-card--totals .naplex-prep-area-name {\n  color: #93c5fd;\n}\n\n.mpje-prep .naplex-prep-area-card--totals .naplex-prep-area-node {\n  background: rgba(59, 130, 246, 0.08);\n  border-color: rgba(59, 130, 246, 0.16);\n}\n\n.mpje-prep .naplex-prep-compare-card--us {\n  border-color: rgba(59, 130, 246, 0.28);\n}\n\n.mpje-prep .naplex-prep-compare-card--us .naplex-prep-compare-label {\n  color: #93c5fd;\n}\n\n.mpje-prep .naplex-prep-compare-card--us .naplex-prep-compare-icon {\n  color: #60a5fa;\n}\n\n.mpje-prep .naplex-prep-price-amount {\n  color: #93c5fd;\n}\n\n/* MPJE founders banner — overrides green→blue from NaplexPrep.css */\n.mpje-prep .naplex-prep-founders-banner {\n  background: rgba(59, 130, 246, 0.10);\n  border-color: rgba(59, 130, 246, 0.35);\n  color: #93c5fd;\n  box-shadow: 0 0 22px rgba(59, 130, 246, 0.10), inset 0 0 0 1px rgba(255,255,255,0.02);\n}\n\n.mpje-prep .naplex-prep-founders-dot {\n  background: #93c5fd;\n  box-shadow: 0 0 8px rgba(147, 197, 253, 0.85);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
